export const isValidPolishNip = (nipRaw: string | null | undefined): boolean => {
  if (!nipRaw) return false;
  const nip = nipRaw.replace(/\D/g, "");
  if (nip.length !== 10) return false;

  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const digits = nip.split("").map((d) => parseInt(d, 10));
  const controlSum = weights.reduce(
    (sum, weight, index) => sum + weight * digits[index],
    0
  );
  const controlNum = controlSum % 11;

  return controlNum === digits[9];
};